// The display half of the track table: the tag and icon a unit header shows.
// Section dividers are content (`<section>.title`/`.sub`), not track UI, since
// one section mixes tracks.
import type { Track } from "@aybuben/core/content/types.ts";
import { BookOpen, CaseLower, CaseUpper, MessagesSquare, type LucideIcon } from "lucide-react";

import type { UiKey } from "../i18n/index.tsx";

export interface TrackUi {
	tagKey: UiKey;
	icon: LucideIcon;
}

export const TRACK_UI: Record<Track, TrackUi> = {
	lower: { tagKey: "home.tag.lower", icon: CaseLower },
	caps: { tagKey: "home.tag.caps", icon: CaseUpper },
	grammar: { tagKey: "home.tag.grammar", icon: BookOpen },
	vocab: { tagKey: "home.tag.vocab", icon: MessagesSquare },
};
